var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0258 3.88037C11.6125 3.88037 8.02581 7.46704 8.02581 11.8804V15.7337C8.02581 16.547 7.67914 17.787 7.26581 18.4804L5.73247 21.027C4.78581 22.6004 5.43914 24.347 7.17247 24.9337C12.9191 26.8537 19.1191 26.8537 24.8658 24.9337C26.4791 24.4004 27.1858 22.4937 26.3058 21.027L24.7725 18.4804C24.3725 17.787 24.0258 16.547 24.0258 15.7337V11.8804C24.0258 7.48037 20.4258 3.88037 16.0258 3.88037Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4929 4.26643C18.0796 4.14643 17.6529 4.05309 17.2129 3.99976C15.9329 3.83976 14.7062 3.93309 13.5596 4.26643C13.9462 3.27976 14.9062 2.58643 16.0262 2.58643C17.1462 2.58643 18.1062 3.27976 18.4929 4.26643Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0264 25.4136C20.0264 27.6136 18.2264 29.4136 16.0264 29.4136C14.933 29.4136 13.9197 28.9602 13.1997 28.2402C12.4797 27.5202 12.0264 26.5069 12.0264 25.4136",
    stroke: "#999999",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.6ff6687d0c8db98537106b54c53bcb52.svg";
export { ForwardRef as ReactComponent };